import React, { useEffect, useState } from "react";
import { PAGE } from "../../constants/page";
import { useDispatch } from "react-redux";
import TabComponent from "../../components/TabComponent";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import {
  resetBreadcrum,
  updateBreadcrum,
} from "../../redux/reducers/BreadcrumbSlice";
import { Trans } from "react-i18next";
import { useAuth } from "react-oidc-context";
import "../../styles/components/Admin/StateAdminHome.scss";
import { useAppSelector } from "../../redux/hooks";
import { UserState } from "../../redux/reducers/UserSlice";
import { updatedAsha } from "src/redux/reducers/AuthAshaDetailsSlice";

function StateAdmin() {
  const [key, setKey] = useState("district");
  const auth = useAuth();
  const adminList = [
    {
      adminRoute: "asha",
      title: "ASHA",
      translationKey: "asha",
    },
    {
      adminRoute: "patient",
      title: "Patients",
      translationKey: "patients",
    },
  ];

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const userDetails: any = useAppSelector(UserState);
  const state = userDetails?.userDetails?.user_metadata?.address?.region;
  const activeTabValue: string = location.pathname.split("/").pop() || "";

  const handleTabChange = (userType: string) => {
    dispatch(updatedAsha({ updated: false }));
    navigate(`${PAGE.STATE_ADMIN}/${userType}`);
  };

  const handleBrowserBackButton = async (e: any) => {
    // to avoid back when on home page
    e.preventDefault();
    navigate(`${PAGE.STATE_ADMIN}/asha`);
  };

  useEffect(() => {
    dispatch(resetBreadcrum());
    dispatch(
      updateBreadcrum({
        routeHistory: [
          {
            label: state,
            label_key: "",
            path: `${PAGE.STATE_ADMIN}/asha`,
            id: "state_admin",
            value: "",
          },
        ],
        display: false,
      })
    );
    window.addEventListener("popstate", handleBrowserBackButton);
    return () => {
      window.removeEventListener("popstate", handleBrowserBackButton);
    };
  }, []);

  return (
    <>
      <div className="bg-light-gray">
        <div className="container">
          <h1 className="titleStateName">
            <Trans i18nKey={"welcome"}></Trans>{" "}
            {auth?.user?.profile.given_name || ""}
          </h1>
        </div>
      </div>
      <TabComponent
        tabList={adminList}
        handleTabChange={handleTabChange}
        activeValue={activeTabValue}
      />
      <Outlet />
    </>
  );
}

export default StateAdmin;
